import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policies', // see below about selector renaming
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.scss']
})
export class PoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
